import {
	ifAuthenticated,
	ifNotAuthenticated,
	ifAuthenticatedOnline,
	AppTabs,
	Edit,
	Create,
	Index
} from '@/router/index'

import Dashboard from '@/components/Dashboard'

export const dashboard = [
	{
		path: '/dashboard',
		component: AppTabs,
		beforeEnter: ifAuthenticatedOnline,
		props: {
			tabs: [
				{
					to: '/dashboard/',
					text: 'Dashboard'
				}
			],
			propStyle: {
				display: 'flex;',
				'flex-direction': 'column !important;',
				height: '91%;'
			}
		},
		children: [
			{
				path: '/dashboard/',
				beforeEnter: ifAuthenticatedOnline,
				component: Dashboard,
				props: {
					modelDef: 'dashboard',
					'action-icon': 'dashboard',
					title: 'Dashboard'
				}
			}
		]
	}
]
